'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * @param {string} usage
 */
function wrappedPortalIdParser(usage) {
  var result = _hubspot2.default.get();

  if (typeof result !== 'number') {
    window.Raven.captureMessage('WRAPPED_PORTAL_ID_PARSER_ERROR', {
      extra: {
        result: result,
        usage: usage
      },
      level: 'info'
    });
  }

  return result;
}

exports.default = wrappedPortalIdParser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/wrappedPortalIdParser.js
// module id = 86
// module chunks = 2 3